import { Badge } from "../../../../../@/components/ui/badge";
import { TableCell, TableRow } from "../../../../../@/components/ui/table";
import React, { useState } from "react";

interface LeadTableRowProps {
  lead: any;
  currentPage: number;
  index: number;
  isSelected: boolean;
  onClick: () => void;
}

// const formatUser = (userId: string) => {
//   return userId.replace("@c.us", "");
// };

export default function LeadTableRowComponent({
  lead,
  currentPage,
  index,
  isSelected,
  onClick,
}: LeadTableRowProps) {
  const [itemsPerPage] = useState(10);
  console.log("hello order", lead);

  return (
    <>
      <TableRow
        key={lead._id}
        onClick={onClick}
        className={`cursor-pointer transition-colors ${
          isSelected ? "bg-gray-200" : "hover:bg-gray-50"
        }`}
      >
        <TableCell className="w-[5vw] ">
          {(currentPage - 1) * itemsPerPage + index + 1}
        </TableCell>
        <TableCell className="pt-2 pb-2 break-words">
          <div className="font-medium capitalize ">
            {/* {order.billing_details?.name || "Unknown User"} */}
            {lead.lead_data.name || "Unknown User"}
          </div>
          {/* <div className="hidden text-sm text-muted-foreground md:inline"> */}
          {/* {order.billing_details?.phone || (order.user?.length > 0 ? formatUser(order.user[0]) : "Phone Number Not Specified")} */}

          {/* </div> */}
        </TableCell>

        <TableCell className="sm:table-cell break-words">
          <Badge
            className="text-xs ring-1 ring-blue-500 text-blue-500"
            variant="secondary"
          >
            {/* {order.status.length > 0
              ? statusMap[order.status[order.status.length - 1].activity] ||
                "Unknown Status"
              : "No Status"} */}
            {lead.lead_data.status || "No status"}
          </Badge>
        </TableCell>

        {lead.lead_data?.fields &&
          Object.entries(lead.lead_data.fields).map(([key, value]) => (
            <TableCell key={key} className="hidden md:table-cell break-words">
              <div className="text-sm">{String(value) || "N/A"}</div>
            </TableCell>
          ))}

        {/* 
        <TableCell className="hidden md:table-cell">
          {order.status.length > 0
            ? new Date(
                order.status[order.status.length - 1].timestamp
              ).toLocaleDateString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              })
            : "No Date"}
        </TableCell> */}
        {/* <TableCell className="hidden md:table-cell">
          {order.product_details.length > 0
            ? order.product_details
                .map((product: any) => product.name)
                .join(", ")
            : "No Products"}
        </TableCell> */}

        {/* <TableCell className="text-right">
          {(order.sale_price / 100).toFixed(2)}
        </TableCell> */}
      </TableRow>
    </>
  );
}
